import AddSubjektBezPripomienokAdminPage from './AddSubjektBezPripomienokAdminPage';

export default AddSubjektBezPripomienokAdminPage;
